import React, { useEffect, useState } from 'react';
import { Row, Col, Typography, Space } from 'antd';
import { useSelector } from 'react-redux';
import { QRCodeSVG } from 'qrcode.react';
import './_qrsection.scss';

const { Title, Text } = Typography;

interface QRSectionProps {
  title?: string;
  subtitle?: string;
  className?: string;
}

const QRSection: React.FC<QRSectionProps> = ({
  title = "Your benefits, one tap away",
  subtitle = "Scan the QR code to download the app now",
  className = ''
}) => {
  const organisationUuid = useSelector((state: any) => state.auth?.organisation_uuid);
  const primaryColor = useSelector((state: any) => state.theme?.primaryColor);
  const brokerName = useSelector((state: any) => state.theme?.brokerName);
  const mobileAppLinks = useSelector((state: any) => state.theme?.mobileAppLinks);
  const [qrUrl, setQrUrl] = useState('');
  const [initials, setInitials] = useState('');

  const hasAppLinks = (mobileAppLinks?.ios || mobileAppLinks?.android) && mobileAppLinks?.is_enabled;

  useEffect(() => {
    const baseUrl = window.location.origin;
    const appRedirectUrl = `${baseUrl}/app-redirect${organisationUuid ? `?organisation_uuid=${organisationUuid}` : ''}`;
    setQrUrl(appRedirectUrl);
  }, [organisationUuid]);

  useEffect(() => {
    if (brokerName) {
      const words = brokerName.trim().split(' ');
      if (words.length >= 2) {
        setInitials((words[0][0] + words[1][0]).toUpperCase());
      } else {
        setInitials(brokerName.substring(0, 1).toUpperCase());
      }
    }
  }, [brokerName]);

  const qrColor = '#525252';

  if (!hasAppLinks) {
    return null;
  }

  return (
    <Row align="middle" className={`qr-section ${className}`}>
      <Col flex="auto">
        <Space direction="vertical" size={4}>
          <Title level={4} className="qr-title">
            {title}
          </Title>
          <Text className="qr-subtitle">{subtitle}</Text>
        </Space>
      </Col>
      <Col flex="none" className="qr-image-col">
        {qrUrl && (
          <div className="qr-code-wrapper">
            <QRCodeSVG
              value={qrUrl}
              size={96}
              level="H"
              fgColor={qrColor}
              bgColor="#FFFFFF"
              includeMargin={false}
              className="qr-code"
              imageSettings={{
                src: `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="48" fill="white"/><circle cx="50" cy="50" r="46" fill="${qrColor}"/><text x="50" y="50" text-anchor="middle" dominant-baseline="central" font-family="Arial, sans-serif" font-size="32" font-weight="bold" fill="white">${initials}</text></svg>`)}`,
                height: 24,
                width: 24,
                excavate: true,
              }}
            />
          </div>
        )}
      </Col>
    </Row>
  );
};

export default QRSection;
